import { render, staticRenderFns } from "./country-detail.vue?vue&type=template&id=87313e5e"
import script from "./country-detail.vue?vue&type=script&lang=ts"
export * from "./country-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports